import { getElement } from "./helpers";
import { removeModal } from "./Modal/modal";
import { Store } from "./store";

/**
 * Unmounts the payment plan from the dom
 */
export function unmount(store: Store, unsubscribe: () => void) {
  const selector = store.getEmbeddedSelector();

  removeModal(false);
  unsubscribe();

  // This condition is to avoid cleaning the DOM, if it is already removed
  if (!selector) {
    return;
  }
  const embeddedParent = getElement(selector);
  store.setEmbeddedSelector(null);

  if (embeddedParent && embeddedParent.firstChild) {
    embeddedParent.removeChild(embeddedParent.firstChild);
  }
}
